import * as React from 'react';
import { Button, View, Text, StyleSheet , Dimensions} from 'react-native';
import Follow from '../../components/Shared/Follow';
import Networks from '../../components/Shared/Networks';
import { themePattern } from '../../constants/pattern';
import { PropsStackShared, RootStackParamList } from './../../types';
const { width, height } = Dimensions.get('window')


export default function SharedDesktop({ navigation }: PropsStackShared) {
  return (
    <View style={styles.Main}>
      <View style={styles.top}>
        <Follow key={1} />
      </View>
      <View style={styles.space}>
      </View>
      <View style={styles.down}>

        <Networks key={2} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  Main: {
    padding:15,
    margin: width > 1200 ? themePattern.desktop.retreatDesketop : themePattern.desktop.retreat,
    width: width > 1200 ? 1200 : 'auto',
    marginTop: 15,
    marginBottom: 15,
    textAlign: 'center',
    alignContent: 'center',
    justifyContent: 'space-between',
    flex:1,
    flexDirection: 'row',
    backgroundColor: width <= 800 ? '#f2f2f2' : 'white',
    borderRadius: 15,
    
  },
  top: {
    borderColor: themePattern.desktop.black,
    borderStyle: 'solid',
    flex:5,
    borderWidth: 2,
    borderBottomWidth: 1,
    borderRadius: 15,
  },
  space:{
      flex:1
  },
  down: {
    borderColor: themePattern.desktop.black,
    borderStyle: 'solid',
    flex:5,
    borderWidth: 2,
    borderTopWidth: 1,
    borderRadius: 15,
    backgroundColor: themePattern.desktop.color1,
  }
});